module.exports = __webpack_public_path__ + "img/1440.9c60423d.jpg";